
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import template from './author.twig';
const allAuthors = [
  {
    name: 'Bubba B-Man',
    avatar: '/media/avatar-buster-a.jpg',
    link: '#',
  },
  {
    name: 'Ozzbot Ozworth',
    avatar: '/media/avatar-ozzie-a.jpg',
    link: '#',
  },
  {
    name: 'Buster Sticka',
    avatar: '/media/avatar-buster-b.jpg',
    link: '#',
  },
  {
    name: 'Ozzie Notarte',
    avatar: '/media/avatar-ozzie-b.jpg',
    link: '#',
  },
];
const authors = (count = 1) => allAuthors.slice(0, count);
const authorsWithNoLink = (count = 1) =>
  allAuthors
    .map(({ name, avatar }) => ({
      name,
      avatar,
    }))
    .slice(0, count);


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Components/Author" argTypes={{
      count: {
        type: 'number',
        description: 'Number of authors to show',
        control: {
          type: 'range',
          min: 1,
          max: allAuthors.length,
          step: 1
        }
      }
    }} mdxType="Meta" />
    <h1>{`Author`}</h1>
    <p>{`Displays an author, or set of authors, with optional meta content.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Basic usage" args={{
        count: 1
      }} mdxType="Story">
    {args => template({
          authors: authorsWithNoLink(args.count)
        })}
  </Story>
    </Canvas>
    <h2>{`With `}<inlineCode parentName="h2">{`link`}</inlineCode></h2>
    <p>{`If an author object contains the optional `}<inlineCode parentName="p">{`link`}</inlineCode>{` property, then the author name will be linked.`}</p>
    <p>{`If you don't want a link, you can use the `}<inlineCode parentName="p">{`unlink`}</inlineCode>{` property to remove it.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="With link" args={{
        count: 1
      }} mdxType="Story">
    {args => template({
          authors: authors(args.count),
          unlink: false
        })}
  </Story>
  <Story name="Remove link" args={{
        count: 1
      }} mdxType="Story">
    {args => template({
          authors: authors(args.count),
          unlink: true
        })}
  </Story>
    </Canvas>
    <h2>{`With `}<inlineCode parentName="h2">{`meta`}</inlineCode>{` content`}</h2>
    <p>{`You can use the `}<inlineCode parentName="p">{`meta`}</inlineCode>{` property to add meta content, for example, the author title.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="With meta content" args={{
        count: 1
      }} mdxType="Story">
    {args => template({
          authors: authors(args.count),
          meta: 'Front-end Designer'
        })}
  </Story>
    </Canvas>
    <h2>{`With `}<inlineCode parentName="h2">{`date`}</inlineCode>{` content`}</h2>
    <p>{`If a date is desired for the meta content, use the `}<inlineCode parentName="p">{`date`}</inlineCode>{` property with a
date object value. The Author template has extra logic to create a more
accessible user experience.`}</p>
    <p>{`If used in a space-constrained area, you may set the `}<inlineCode parentName="p">{`date_format`}</inlineCode>{` property
to "short" to display an abbreviated version. (e.g. `}<inlineCode parentName="p">{`Mar 31, 2021`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`March 31st, 2021`}</inlineCode>{`)`}</p>
    <p><strong parentName="p">{`Note:`}</strong>{` The `}<inlineCode parentName="p">{`meta`}</inlineCode>{` property will override the `}<inlineCode parentName="p">{`date`}</inlineCode>{` if both are set.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="With date content" args={{
        count: 1
      }} mdxType="Story">
    {args => template({
          authors: authors(args.count),
          date: new Date('September 29, 2021')
        })}
  </Story>
  <Story name="Short date format" args={{
        count: 1
      }} mdxType="Story">
    {args => template({
          authors: authors(args.count),
          date: new Date('September 29, 2021'),
          date_format: 'short'
        })}
  </Story>
    </Canvas>
    <h2>{`Multiple authors`}</h2>
    <p>{`Multiple authors are also supported.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Multiple authors" args={{
        count: 3
      }} mdxType="Story">
    {args => template({
          authors: authors(args.count),
          date: new Date('March 31, 2021')
        })}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <p><inlineCode parentName="p">{`class`}</inlineCode>{` (string): CSS class(es) to append to the root element`}</p>
    <p><inlineCode parentName="p">{`authors`}</inlineCode>{` (array): Array of `}<a parentName="p" {...{
        "href": "https://timber.github.io/docs/reference/timber-user/#properties"
      }}>{`author objects`}</a>{`, each containing:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`name`}</inlineCode>{` (string): The author's name.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`avatar`}</inlineCode>{` (string): A URL for the author's avatar. For more complex customization, use the `}<inlineCode parentName="li">{`avatars`}</inlineCode>{` block.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`link`}</inlineCode>{` (optional, string): An `}<inlineCode parentName="li">{`href`}</inlineCode>{` for the author's name to link to, for example a bio page.`}</li>
    </ul>
    <p><inlineCode parentName="p">{`author_prefix`}</inlineCode>{` (optional, string, default "By"): Used to create a more
accessible user experience by adding visually hidden text, prefixes the author name (e.g. "By Jane Doe")`}</p>
    <p><inlineCode parentName="p">{`meta`}</inlineCode>{` (optional, string): Extra information to be rendered below the author name(s)`}</p>
    <p><inlineCode parentName="p">{`date`}</inlineCode>{` (optional, date object): Represents a publication date`}</p>
    <p><inlineCode parentName="p">{`date_format`}</inlineCode>{` (optional, string): Set to `}<inlineCode parentName="p">{`short`}</inlineCode>{` to use abbreviated date formatting. (e.g. `}<inlineCode parentName="p">{`Mar 31, 2021`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`March 31st, 2021`}</inlineCode>{`)`}</p>
    <p><inlineCode parentName="p">{`date_prefix`}</inlineCode>{` (optional, string, default "Published on"): Used to create a more
accessible user experience by adding visually hidden text, prefixes the date value (e.g. "Published on March 31st, 2021")`}</p>
    <p><inlineCode parentName="p">{`unlink`}</inlineCode>{` (optional, boolean): Used to remove the link from an author that contains a `}<inlineCode parentName="p">{`link`}</inlineCode>{` property.`}</p>
    <h2>{`Template Blocks`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`authors`}</inlineCode>{`: The author links to display.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`avatars`}</inlineCode>{`: The `}<a parentName="li" {...{
          "href": "/?path=/docs/components-avatar--empty"
        }}>{`Avatars`}</a>{`, which will be passed to a `}<a parentName="li" {...{
          "href": "/?path=/docs/objects-bunch--of-avatars"
        }}>{`Bunch`}</a>{`. Use this if you want to make deeper customizations to the avatars, for example adding `}<inlineCode parentName="li">{`srcset`}</inlineCode>{` and `}<inlineCode parentName="li">{`sizes`}</inlineCode>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`meta_content`}</inlineCode>{`: The date or other additional content to display.`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const basicUsage = (args => template({
  authors: authorsWithNoLink(args.count)
}));
basicUsage.storyName = 'Basic usage';
basicUsage.args = {
  count: 1
};
basicUsage.parameters = { storySource: { source: 'args => template({\n  authors: authorsWithNoLink(args.count)\n})' } };

export const withLink = (args => template({
  authors: authors(args.count),
  unlink: false
}));
withLink.storyName = 'With link';
withLink.args = {
  count: 1
};
withLink.parameters = { storySource: { source: 'args => template({\n  authors: authors(args.count),\n  unlink: false\n})' } };

export const removeLink = (args => template({
  authors: authors(args.count),
  unlink: true
}));
removeLink.storyName = 'Remove link';
removeLink.args = {
  count: 1
};
removeLink.parameters = { storySource: { source: 'args => template({\n  authors: authors(args.count),\n  unlink: true\n})' } };

export const withMetaContent = (args => template({
  authors: authors(args.count),
  meta: 'Front-end Designer'
}));
withMetaContent.storyName = 'With meta content';
withMetaContent.args = {
  count: 1
};
withMetaContent.parameters = { storySource: { source: 'args => template({\n  authors: authors(args.count),\n  meta: \'Front-end Designer\'\n})' } };

export const withDateContent = (args => template({
  authors: authors(args.count),
  date: new Date('September 29, 2021')
}));
withDateContent.storyName = 'With date content';
withDateContent.args = {
  count: 1
};
withDateContent.parameters = { storySource: { source: 'args => template({\n  authors: authors(args.count),\n  date: new Date(\'September 29, 2021\')\n})' } };

export const shortDateFormat = (args => template({
  authors: authors(args.count),
  date: new Date('September 29, 2021'),
  date_format: 'short'
}));
shortDateFormat.storyName = 'Short date format';
shortDateFormat.args = {
  count: 1
};
shortDateFormat.parameters = { storySource: { source: 'args => template({\n  authors: authors(args.count),\n  date: new Date(\'September 29, 2021\'),\n  date_format: \'short\'\n})' } };

export const multipleAuthors = (args => template({
  authors: authors(args.count),
  date: new Date('March 31, 2021')
}));
multipleAuthors.storyName = 'Multiple authors';
multipleAuthors.args = {
  count: 3
};
multipleAuthors.parameters = { storySource: { source: 'args => template({\n  authors: authors(args.count),\n  date: new Date(\'March 31, 2021\')\n})' } };

const componentMeta = { title: 'Components/Author', argTypes: {
  count: {
    type: 'number',
    description: 'Number of authors to show',
    control: {
      type: 'range',
      min: 1,
      max: allAuthors.length,
      step: 1
    }
  }
}, includeStories: ["basicUsage","withLink","removeLink","withMetaContent","withDateContent","shortDateFormat","multipleAuthors"],  };

const mdxStoryNameToKey = {"Basic usage":"basicUsage","With link":"withLink","Remove link":"removeLink","With meta content":"withMetaContent","With date content":"withDateContent","Short date format":"shortDateFormat","Multiple authors":"multipleAuthors"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;